<template>
  <div class="angle-base">
    <Steps
      v-if="step1"
      :title="$t('edit.angle.angleRange')"
      :isShowArrow="true"
      displayType
      @clickBack="onClickBack"
      @onClickNext="onClickNext"
    >
      <template slot="body">
        <div class="adjust-item">
          <div
            class="item"
            :class="{seleced: selectedSet.type === item.type}"
            v-for="item in settingItems"
            :key="item.title"
            @click="onClickAdjust(item)"
          >
            <div class="icon-wrapper">
              <a-icon style="fontSize:18px" :type="item.icon"></a-icon>
            </div>
            <span>{{item.title}}</span>
          </div>
        </div>
        <div>
          <div v-if="showDep" class="bottom-base">
            <!-- <div class="container-set">
              <a-slider
                :max="currentAngle.fovrange.max"
                :min="currentAngle.fovrange.min"
                id
                v-model="currentAngle.fovrange.default"
              />
              <div class="titles">
                <span></span>
                <span>初始</span>
              </div>
              <a-slider
                :max="fovrangeMax"
                :min="fovrangeMin"
                range
                :value="[currentAngle.fovrange.min, currentAngle.fovrange.max]"
                @change="handleChangeFovrangeSlide"
              />
              <div class="titles">
                <span>最近</span>
                <span>最遠</span>
              </div>
            </div> -->
            <div class="container-set">
              <CSlider :max="fovrangeMax" :min="fovrangeMin" v-model="currentModel"></CSlider>
            </div>
            <div class="container-set">
              <div class="titles">
                <span>{{$t('edit.angle.fovrangeMin')}}</span>
                <span>{{$t('edit.angle.default')}}</span>
                <span>{{$t('edit.angle.fovrangeMax')}}</span>
              </div>
            </div>
            <div class="resetBtn" @click="resetData">{{$t('actionTitles.reset')}}</div>
          </div>
          <div v-if="showH" class="bottom-base">
            <div class="container-set">
              <a-slider
                :max="vviewMax"
                :min="vviewMin"
                range
                :value="[
        this.currentAngle.viewrange.vview.min,
        this.currentAngle.viewrange.vview.max,
      ]"
                @change="handleChangeVviewSlide"
              />
              <div class="titles">
                <span>{{$t('edit.angle.vviewMin')}}</span>
                <span>{{$t('edit.angle.vviewMax')}}</span>
              </div>
            </div>
            <div class="resetBtn" @click="resetData">{{$t('actionTitles.reset')}}</div>
          </div>
          <div v-if="showV" class="bottom-base">
            <div class="container-set">
              <a-slider
                :max="hviewMax"
                :min="hviewMin"
                range
                :value="[
        this.currentAngle.viewrange.hview.min,
        this.currentAngle.viewrange.hview.max,
      ]"
                @change="handleChangeHviewSlide"
              />
              <div class="titles">
                <span>{{$t('edit.angle.hviewLeft')}}</span>
                <span>{{$t('edit.angle.hviewRight')}}</span>
              </div>
            </div>
            <div class="resetBtn" @click="resetData">{{$t('actionTitles.reset')}}</div>
          </div>
        </div>
      </template>
    </Steps>

    <Steps
      v-if="step2"
      :title="$t('edit.angle.toScene')"
      :isLast="true"
      :isShowArrow="true"
      @clickBack="onBackPre"
      @onClickFinish="onClickFinish"
    >
      <template slot="body">
        <div class="scroll-base">
          <div class="item-wrapper">
            <ImageItem
              :itemObj="value"
              v-for="(value, k) in this.vrbase.scenes"
              :key="k"
              :selected="selectedScene"
              @click.native="selectScene(value)"
            ></ImageItem>
          </div>
        </div>
      </template>
    </Steps>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Steps from "../../Steps.vue";
import ImageItem from "../../ImageItem.vue";
import  CSlider from "../../../component/CSlider.vue";

const defaultAngle = {
  initview: { hlookat: 123, vlookat: 34 },
  fovrange: { min: 0, max: 140, default: 120 },
  viewrange: {
    hview: { min: -180, max: 180 },
    vview: { min: -180, max: 180 },
  },
};

export default {
  components: { Steps, ImageItem, CSlider },
  data() {
    return {
      settingItems: [
        {
          title: this.$t('edit.angle.fovrange'),
          type: 1,
          icon: "vertical-align-top",
        },
        {
          title: this.$t('edit.angle.vview'),
          type: 2,
          icon: "column-height",
        },
        {
          title: this.$t('edit.angle.hview'),
          type: 3,
          icon: "column-width",
        },
      ],
      step1: true,
      step2: false,
      selectedSet: {},
      showDep: false,
      showH: false,
      showV: false,
      sceneList: [],
      fovrangeMin: 0,
      fovrangeMax: 140,
      hviewMin: -180,
      hviewMax: 180,
      vviewMin: -90,
      vviewMax: 90,
      currentAngle: defaultAngle,
      modalVisible: false,
      selectedScene: [],
      currentModel: {
        left: 0,
        center: 120,
        right: 120
      }
    };
  },
  computed: {
    ...mapGetters(["vrbase", "currentScenesId"]),
  },
  created() {
    this.initData();
    this.currentAngle = this.$deepClone(
      this.vrbase.scenes[this.currentScenesId].angle
    );
    this.currentModel = {
      left: this.currentAngle.fovrange.min,
      center: this.currentAngle.fovrange.default,
      right: this.currentAngle.fovrange.max
    }
  },
  watch: {
    currentAngle: {
      handler: function (value) {
        setSceneAngle(value);
      },
      immediate: true,
      deep: true,
    },
    currentModel: {
      handler: function (value) {
        this.currentAngle.fovrange.min = value.left;
        this.currentAngle.fovrange.max = value.right;
        this.currentAngle.fovrange.default = value.center;
      },
      deep: true,
    }
  },
  methods: {
    resetData() {
      this.currentAngle = this.$deepClone(defaultAngle);
      this.currentModel = {
        left: this.currentAngle.fovrange.min,
        center: this.currentAngle.fovrange.default,
        right: this.currentAngle.fovrange.max
      }
    },
    initData() {
      this.selectedSet = this.settingItems[0];
      this.showDep = true;
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    onClickNext() {
      this.step1 = false;
      this.step2 = true;
    },
    onBackPre() {
      this.step1 = true;
      this.step2 = false;
    },
    onClickAdjust(item) {
      this.selectedSet = item;
      const value = item.type;
      const typeObj = {
        dep: value === 1,
        h: value === 2,
        v: value === 3,
      };
      this.showDep = typeObj.dep;
      this.showH = typeObj.h;
      this.showV = typeObj.v;
    },
    //判斷當前視角是否在垂直和水平視角內
    judgeView(){
      const hMax = this.currentAngle.viewrange.hview.max
      const hMin = this.currentAngle.viewrange.hview.min
      const vMax = this.currentAngle.viewrange.vview.max
      const vMin = this.currentAngle.viewrange.vview.min
      const hlookat = this.currentAngle.initview.hlookat
      const vlookat = this.currentAngle.initview.vlookat
      const h = hlookat <= hMax && hlookat >= hMin ? true : false
      const v = vlookat <= vMax && vlookat >=vMin ? true : false
      /*if(h && v){
        this.currentAngle.initview = getSceneViewAt();
      }*/
      if(!h){
        this.currentAngle.initview.hlookat = (hMax + hMin) / 2
      }
      if(!v){
        this.currentAngle.initview.vlookat = (vMax + vMin) / 2
      }
    },
    onClickFinish() {
      this.judgeView()
      // this.currentAngle.initview = getSceneViewAt();
      this.vrbase.scenes[this.currentScenesId].angle = this.currentAngle;
      let selectedSceneIds = this.sceneList.map((s) => {
        return s.scene_id;
      });
      selectedSceneIds.forEach((sceneId) => {
        this.vrbase.scenes[sceneId].angle = this.$deepClone(this.currentAngle);
      });
      this.$store.dispatch("setVRBase", this.vrbase);
      this.$store.dispatch("saveVRBase", {vrbase: this.vrbase, showLoading: true})
      this.$emit("onClickBack");
    },

    handleChangeFovrangeSlide(value) {
      this.currentAngle.fovrange.min = value[0];
      this.currentAngle.fovrange.max = value[1];
    },
    handleChangeVviewSlide(value) {
      this.currentAngle.viewrange.vview.min = value[0];
      this.currentAngle.viewrange.vview.max = value[1];
    },
    handleChangeHviewSlide(value) {
      this.currentAngle.viewrange.hview.min = value[0];
      this.currentAngle.viewrange.hview.max = value[1];
    },
    selectScene(item) {
      // 沒有加，有則移除
      for (var i = 0; i < this.selectedScene.length; i++) {
        if (this.selectedScene[i].scene_id === item.scene_id) {
          this.selectedScene.splice(i, 1);
          return;
        }
      }
      this.selectedScene.push(item);
    },
  },
};
</script>

<style lang="less" scoped>
.angle-base {
  /*padding: 5px 10px;*/
  .bottom-base {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .container-set {
      width: 100%;
      padding: 0 4px;
      .titles {
        display: flex;
        justify-content: space-between;
      }
    }
    .resetBtn{
      width: 100%;
      border: 1px dashed rgba(255,255,255,.1);
      margin: 15px 0 5px 0;
      padding: 10px 0;
      display: flex;
      justify-content: center;
      background: rgba(0,0,0,.1);
    }
  }
}
</style>
